import React, { forwardRef, useImperativeHandle, useState } from 'react';
import IconCheck from '../../assets/icons/IconCheck';

const ButtonToggle = ({ className = '', onClick = () => {} }, ref) => {
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({
        onClick: _handleClickToggle
    }));

    const _handleClickToggle = () => {
        setVisible((prev) => {
            onClick(!prev);
            return !prev;
        });
    };

    return (
        <div className={`btn-toggle ${className} ${visible ? 'active' : ''}`} onClick={_handleClickToggle}>
            <div className="circle">
                <IconCheck isBlack={!visible} />
            </div>
        </div>
    );
};

export default forwardRef(ButtonToggle);
